import { render } from "./IntroText.vue?vue&type=template&id=06829724"
import script from "./IntroText.vue?vue&type=script&lang=js"
export * from "./IntroText.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__